import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function InvestorConnect() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', firm: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <InfoPage
      eyebrow={t('info.company')}
      title={t('investorConnect.title')}
      subtitle={t('investorConnect.subtitle')}
    >
      {submitted ? (
        <p className="info-form-success">{t('investorConnect.successMessage', { name: form.name, email: form.email })}</p>
      ) : (
        <form className="info-form" onSubmit={handleSubmit}>
          <input required placeholder={t('investorConnect.yourName')} value={form.name} onChange={update('name')} />
          <input required type="email" placeholder={t('investorConnect.yourEmail')} value={form.email} onChange={update('email')} />
          <input placeholder={t('investorConnect.firmOptional')} value={form.firm} onChange={update('firm')} />
          <textarea required placeholder={t('investorConnect.tellUs')} value={form.message} onChange={update('message')} />
          <button type="submit">{t('investorConnect.submitInquiry')}</button>
        </form>
      )}
    </InfoPage>
  );
}
